var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.5a1.5 1.5 0 0 0-1.376.9a1 1 0 0 1-1.832-.8q.165-.376.408-.7a3.5 3.5 0 1 1 4.294 5.266a1.3 1.3 0 0 0-.414.293c-.08.092-.08.137-.08.142c0 .037.02.072.052.09l7.543 4.19A2.731 2.731 0 0 1 19.27 19H4.743a2.743 2.743 0 0 1-1.37-5.12L9 10.635a1 1 0 0 1 1 1.732l-5.628 3.247A.743.743 0 0 0 4.743 17H19.27a.731.731 0 0 0 .355-1.37l-7.543-4.191A2.1 2.1 0 0 1 11 9.602c0-1.208.984-1.935 1.64-2.244A1.5 1.5 0 0 0 12 4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerch);
export default __webpack_public_path__ + "static/media/merch.5dff1fe93aafb2328d7b8f85753eda8e.svg";
export { ForwardRef as ReactComponent };